export default {
  show_modal: false,
  show_notification_modal: false
};
